import { Dropdown, DropdownToggle } from 'reactstrap';

import { UserMenu } from '..';
import UserSVG from '../../../../assets//imgs/icon/user.svg';
import { useAppSelector } from '../../../../reduxstore/hooks';
import { useState } from 'react';

export const Button: React.FC = () => {
	const profile = useAppSelector(state => state.accountReducer.profile);
	const name = profile.first_name;

	const [dropdownOpen, setDropdownOpen] = useState(false);

	const toggle = () => setDropdownOpen(prevState => !prevState);

	return (
		<Dropdown
			isOpen={dropdownOpen}
			toggle={toggle}
			className="w-100 h-100 header-user-menu-button"
		>
			<DropdownToggle tag="a" className="d-block w-100 h-100">
				<div className="w-100 h-100 d-flex align-items-center px-3 text-primary text-lightened-primary-hover bg-lightened-primary-hover cursor-pointer rounded-0 bg-primary border-0">
					<div
						style={{
							backgroundColor: '#fff',
							borderRadius: '50%',
							height: '32px',
							width: '32px',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							marginRight: '8px'
						}}
					>
						<img
							style={{
								width: '18px',
								height: '18px'
							}}
							src={UserSVG}
						/>
					</div>
					<div className="text-white">
						{name ? `Welcome back, ${name}` : 'Signing in...'}
					</div>
				</div>
			</DropdownToggle>
			<UserMenu />
		</Dropdown>
	);
};
